<div class="full-width" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="start center" fxFlexOffset="30px">
  <span class="subtitle-default">Total Trading Report</span>

    <span class="fx-spacer"></span>

    <form [formGroup]="reportFormGroup">
      <mat-form-field class="custom-text-field" appearance="outline" floatLabel="always">
        <mat-label>Payment Method</mat-label>
        <input matInput type="text" placeholder="Search here" formControlName="paymentMethod">
      </mat-form-field>
    </form>
    <button
      mat-icon-button
      [matMenuTriggerFor]="mainOptionsMenu"
      matTooltip="Table options"
      [disabled]="!!(loader.loading$ | async)"
    >
      <mat-icon class="crud-table-main-toolbar-icon">download</mat-icon>
    </button>
    <mat-menu #mainOptionsMenu="matMenu">
      <!-- Export to CSV -->
      <button mat-menu-item (click)="exportToCsv()">
        <mat-icon>file_download</mat-icon>
        <span>Export to CSV</span>
      </button>

      <!-- Export to Excel -->
      <button mat-menu-item (click)="exportToExcel()">
        <mat-icon>file_download</mat-icon>
        <span>Export to Excel</span>
      </button>

      <!-- Export to PDF -->
      <button mat-menu-item (click)="exportToPdf()">
        <mat-icon>file_download</mat-icon>
        <span>Export to PDF</span>
      </button>
    </mat-menu>
  </div>

  <div class="mat-elevation-z3 radius-10 bg-white" fxLayout="column" fxFlexOffset="10px">
    <table mat-table class="custom-table chart-table" [dataSource]="totalReportDatasource"
           matSort matSortActive="transactionDate" matSortDirection="desc" #sort="matSort">
      <ng-container matColumnDef="table-label">
        <th mat-header-cell class="custom-table-label" *matHeaderCellDef [attr.colspan]="reportColumns.length"> Total amount received per payment method </th>
        <td mat-footer-cell *matFooterCellDef></td>
      </ng-container>

      <ng-container matColumnDef="transactionDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Trading Date </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{dateUtils.displayDateWithTime(element.transactionDate)}} </td>
        <td mat-footer-cell *matFooterCellDef><span class="heading-default"><strong>Totals:</strong></span></td>
      </ng-container>

      <ng-container matColumnDef="paymentMethod">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Payment Method </th>
        <td mat-cell class="custom-table-cell" *matCellDef="let element"> {{utils.displayStatus(element.paymentMethod)}} </td>
        <td mat-footer-cell *matFooterCellDef></td>

      </ng-container>

      <ng-container matColumnDef="amountReceived">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Amount Received </th>
        <td mat-cell class="custom-table-cell btn-cursor" *matCellDef="let element"> {{utils.displayRandAmountWithDecimal(element.amountReceived)}} </td>
        <td mat-footer-cell *matFooterCellDef><span
          class="heading-default">{{utils.displayRandAmountWithDecimal(getAmountReceivedTotal())}}</span></td>

      </ng-container>

      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="['table-label']"></tr>
      <tr mat-header-row class="custom-table-header" *matHeaderRowDef="reportColumns"></tr>
      <tr mat-row class="custom-table-row" *matRowDef="let row; columns: reportColumns;"></tr>
      <!-- Footer Row -->
      <tr mat-footer-row *matFooterRowDef="reportColumns"></tr>
    </table>
    <mat-paginator #paginator class="custom-paginator"
                   [length]="totalReportDatasource.filteredData.length"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   [pageSize]="5"></mat-paginator>
  </div>
  <div class="info-card-dark" fxLayout="column" fxLayoutGap="20px" fxFlexOffset="30px">
    <span class="heading-bold">Notes</span>
    <span class="body-1-regular-2">Totals are for all the data returned not just the current page</span>
  </div>
</div>
